<template>
  <w-modal
    v-model="show"
    submit-button="Zamknij"
    title="Polityka prywatności"
    class="modal-big"
    :show-close-button="false"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="close"
    @close="close"
  >
    <div v-html="gdprPolicy" />
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { PublicSettings } from '@/enums/publicSettings.enum';
import { modalMixin } from '@/mixins/modal';

export default {
  mixins: [modalMixin],
  computed: mapState({ gdprPolicy: state => state.setting.settings[PublicSettings.GDPR_POLICY].value })
};
</script>
